var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"fixed":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }